import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { AuthService } from '../auth/auth.service';
import { CapabilityEngineService } from '../capabilityEngine.service';
import { FormsListService } from '../forms-list/forms-list.service';
import { FormsPreviewService } from './forms-preview.service';
import * as _ from 'lodash';
declare const Buffer;
declare var $: any;
import { saveAs } from 'file-saver';

@Component({
    selector: 'app-forms-preview',
    templateUrl: './forms-preview.component.html',
    styleUrls: ['./forms-preview.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class FormsPreviewComponent implements OnInit {
    @ViewChild('disp') iframe: ElementRef;
    public data: any;
    public formObj: any = {};
    public preview: any = {};
    formBuilderUrl: string;
    teamId: String;
    previewtext: any;
    sectionArrays: any[] = [];
    obj: any = {};
    object: any;
    basedonCapabilities = true;
    formBuilderDetails: any;
    selectedReport:any;
    reportStatus = [{ key: "DAILY", title: "Daily" }, { key: "WEEKLY", title: "Weekly" }, { key: "MONTHLY", title: "Monthly" }, { key: "QUARTERLY", title: "Quarterly" }];
    colors = ["#96CDE6", "#9A6324", "#92AE31", "#D485B2"];
    constructor(
        private _router: ActivatedRoute,
        private _route: Router,
        private _formsPreviewService: FormsPreviewService,
        private _capabilityEngineService: CapabilityEngineService,
        private _activatedRoute: ActivatedRoute,
        private _authService: AuthService,
        private _formsListService: FormsListService,
        private _domSanitizer: DomSanitizer
    ) { }

    ngOnInit() {
        let userRole = localStorage.getItem('userRole');
        if (userRole === 'supervisor') {
            this.basedonCapabilities = false;
        } else {
            this.basedonCapabilities = true;
        }
        this.object = Object;
        const pathData = this._activatedRoute.data['_value'];
        if (this.canPerform(pathData.capabilities)) {
            console.log(this._router.snapshot.params.id);
            this._formsPreviewService
                .getForm(this._router.snapshot.params.id)
                .subscribe(
                    (result: any) => {
                        this.formsPreview();
                        this.formObj = result.data.templateDetails;

                        if (this.formObj.tag) {
                            _.forEach(this.reportStatus, (report, index) => {
                                if (report.key === this.formObj.tag) {
                                    this.selectedReport = report;
                                    document.getElementById("showColor").style.background = this.colors[index];
                                }
                            })
                        }
                        // let doc = this.iframe.nativeElement.contentDocument || this.iframe.nativeElement.contentWindow;
                        // doc.open();
                        // doc.write(result.data.html);
                        // doc.close();
                    },
                    err => {
                        console.log(err);
                    }
                );
        }

        this.teamId = localStorage.getItem('teamId');

        this.formBuilderDetails = {
            'appId': encodeURIComponent(environment.formBuilder.appId),
            'x-header-authtoken': encodeURIComponent(this._authService.getAuthToken()),
            'x-header-refreshtoken': encodeURIComponent(this._authService.getRefreshToken()),
            'redirectUrl': encodeURIComponent(window.location.href.toString()),
            'formElementsEndPoint': encodeURIComponent('/api/assets/team/'),
            'taskTemplateId': encodeURIComponent(this._router.snapshot.params.id)
        }

        this.formBuilderUrl = environment.formBuilder.serverUrl + '/api/v1/verifyTokens?' + 'data='
            + this.encode(this.formBuilderDetails);
    }
    slectedReport(val, i) {
        if (val !== this.selectedReport) {
            this.selectedReport = val;
            document.getElementById("showColor").style.background = this.colors[i];
        } else {
            this.selectedReport = undefined;
            document.getElementById("showColor").style.background = '#FFF'
        }

        this._formsPreviewService.updateTag(this.selectedReport ? this.selectedReport.key : undefined, this._router.snapshot.params.id)
            .subscribe(
                (result: any) => {
                    console.log('​Form published', result);
                },
                err => {
                    console.log('​Error in form publishing', err);
                }
            );
    }

    encode(data) {
        const dataString = JSON.stringify(data);
        let buffer = new Buffer(dataString);
        let base64data = buffer.toString('base64');
        return base64data;
    }

    canPerform(data) {
        return this._capabilityEngineService.canPerform(data);
    }

    publish() {
        this._formsPreviewService
            .publish(this._router.snapshot.params.id)
            .subscribe(
                (result: any) => {
                    console.log('​Form published', result);
                    this.formObj.status = 0;
                },
                err => {
                    console.log('​Error in form publishing', err);
                }
            );
    }

    formDeactivate() {
        this._formsPreviewService
            .deactivate(this._router.snapshot.params.id)
            .subscribe(
                (result: any) => {
                    console.log('​Form Deactivated', result);
                    this.formObj.status = 2;
                    this._route.navigate(['/formsList']);
                },
                err => {
                    console.log('​Error in form deactivation', err);
                }
            );
    }
    formArchive() {
        this._formsPreviewService
            .archive(this._router.snapshot.params.id)
            .subscribe(
                (result: any) => {
                    this.formObj.status = 3;
                    this._route.navigate(['/formsList']);
                },
                err => {
                    console.log('​Error in form deactivation', err);
                }
            );
    }
    //    utility Functions This will take the Html String and returns Arrays of DOM (take first element)

    getNodes(str) {
        return new DOMParser().parseFromString(str, 'text/html').body.childNodes;
    }

    formsPreview() {
        this._formsPreviewService
            .formpreview(this._router.snapshot.params.id)
            .subscribe(
                (result: any) => {
                    console.log('result ', result);
                    // this.preview = result.data.htmlTemplate;
                    // console.log(this.preview);
                    // let formNodes = this.getNodes(previewhtml)[0];
                    // let pageNodes = this.formNodes.firstChild;

                    // var previewhtml = $('.page')[0].outerHTML;

                    let previewhtml = result.data.htmlTemplate;
                    console.log(previewhtml);

                    // let formNodes = this.getNodes(previewhtml)[0];
                    // let pageNodes = this.formNodes.firstChild;

                    let formNodes = this.getNodes(previewhtml)[0];
                    console.log(formNodes);

                    let pageNodes = formNodes.childNodes[1];
                    console.log(pageNodes);

                    // let pageNodes = this.getNodes(previewhtml)[0];
                    // console.log(pageNodes);
                    this.sectionArrays = [];
                    let children = pageNodes.childNodes;
                    console.log(children);

                    for (let i = 0; i < children.length; i++) {
                        let previewhtmlChildNode = children[i];
                        console.log('html child node', previewhtmlChildNode);
                        let sectionTitle = $(previewhtmlChildNode).children('.section-title').text();
                        console.log('hello section name', sectionTitle);

                        // get html for every field from service

                        // append to a section and display it in sectionContent
                        // let dummy = this.getNodes(previewhtmlChildNode.outerHTML)
                        // let fieldTypesNodes = this.getNodes(previewhtmlChildNode.outerHTML)[0];

                        if (sectionTitle && previewhtmlChildNode && previewhtmlChildNode['outerHTML']) {
                            let fieldsArray = [];
                            let fieldTypesNodes = this.getNodes(previewhtmlChildNode['outerHTML'])[0];
                            // console.log(previewhtmlChildNode);
                            let fieldChildren = fieldTypesNodes.childNodes;
                            // loop over fields and get field-title, field-data, field-options
                            console.log(fieldChildren);
                            for (let j = 0; j < fieldChildren.length; j++) {
                                let fieldItem = fieldChildren[j];
                                // console.log(fieldItem);
                                console.log(fieldChildren[j], 'hello');
                                let fieldTitle = $(fieldItem).attr(
                                    'data-title'
                                );
                                // console.log (fieldTitle, 'hello this is field title');
                                let fieldDataType = $(fieldItem).attr(
                                    'data-type'
                                );
                                // console.log (fieldDataType, 'hello this is field data type');
                                // data required
                                let fieldPropertiesRequired = $(fieldItem).attr(
                                    'data-required'
                                );

                                // data dynamic(bulk)
                                let fieldPropertiesDynamic = $(fieldItem).attr(
                                    'data-dynamic'
                                );

                                // data information
                                let fieldPropertiesInformation = $(
                                    fieldItem
                                ).attr('data-information');

                                // data information
                                let fieldPropertiesLabel = $(fieldItem).attr(
                                    'data-label'
                                );

                                // free form draw
                                let fieldPropertiesDrawImage;
                                let fieldPropertiesPdf;
                                if ($(fieldItem).attr('data-icon')) {
                                    if ($(fieldItem).attr('data-type') === 'freeFormDraw') {
                                        fieldPropertiesDrawImage = 'data:image/png;base64,' + $(fieldItem).attr('data-icon');
                                    } else {
                                        fieldPropertiesPdf = this._domSanitizer.bypassSecurityTrustResourceUrl('data:application/pdf;base64,' + $(fieldItem).attr('data-icon'))
                                    }
                                }

                                // url field
                                let fieldPropertiesUrl = $(fieldItem).attr('data-url');

                                let dataOptions = $(fieldItem).attr(
                                    'data-options'
                                );
                                // let dataHeadingOptions = $(fieldItem).attr('data-headings');
                                // Constants.elementTypes.MultiChoice

                                let fieldDataOptions = [];
                                if (dataOptions) {
                                    fieldDataOptions = JSON.parse(
                                        $(fieldItem).attr('data-options')
                                    );
                                }

                                var fieldPropertiesForm = undefined;
                                if (fieldDataType === 'form') {
                                    const templateData = $(fieldItem).attr('data-prefilled-options');
                                    if (templateData) {
                                        const data = JSON.parse(templateData);
                                        fieldPropertiesForm = data.title;
                                    }
                                }
                                if (fieldDataType === 'multiChoiceHeading') {
                                    let dataHeadings = $(fieldItem).attr(
                                        'data-headings'
                                    );
                                    if (dataHeadings) {
                                        fieldDataOptions = JSON.parse(
                                            $(fieldItem).attr('data-headings')
                                        );
                                    }
                                }
                                console.log('hello field name', fieldTitle);

                                // For PDF
                                if(fieldDataType == "pdf") {
                                    let selectionType = $(fieldItem).attr('data-selected');
                                    if(selectionType) {
                                        selectionType = JSON.parse(selectionType)[0];
                                        switch(selectionType) {
                                            case "select":
                                                let pdfData = $(fieldItem).attr('data-url');
                                                if(pdfData) {
                                                    pdfData = JSON.parse(pdfData)
                                                }
                                                fieldPropertiesPdf = this._domSanitizer.bypassSecurityTrustResourceUrl(pdfData.url)
                                                break;
                                            case "url":
                                                fieldPropertiesPdf = this._domSanitizer.bypassSecurityTrustResourceUrl($(fieldItem).attr('data-url'))
                                                break;
                                            default:
                                                break
                                        }
                                    }
                                }

                                if (fieldTitle) {
                                    let field = {
                                        fieldTitle: fieldTitle,
                                        fieldType: fieldDataType,
                                        fieldOptions: fieldDataOptions,
                                        fieldPropertiesRequired: fieldPropertiesRequired,
                                        fieldPropertiesDynamic: fieldPropertiesDynamic,
                                        fieldPropertiesInformation: fieldPropertiesInformation,
                                        fieldPropertiesLabel: fieldPropertiesLabel,
                                        fieldPropertiesDrawImage: fieldPropertiesDrawImage,
                                        fieldPropertiesUrl: fieldPropertiesUrl,
                                        fieldPropertiesPdf: fieldPropertiesPdf,
                                        fieldPropertiesForm: fieldPropertiesForm
                                    };
                                    console.log(field.fieldTitle);
                                    // console.log(field.fieldPropertiesDynamic)
                                    fieldsArray.push(field);
                                }
                            }

                            let obj = {
                                sectionTitle: sectionTitle,
                                sectionContent: fieldsArray,
                                dynamicSection : $(previewhtmlChildNode).attr('data-section')
                            };
                            // console.log(obj);
                            // console.log(obj.sectionTitle);
                            // this.obj = obj;

                            this.sectionArrays.push(obj);
                            // console.log(this.sectionArrays);
                        }
                    }
                },
                err => {
                    console.log(err);
                }
            );
    }

    onFormEdit() {
        this.formBuilderDetails = {
            'appId': encodeURIComponent(environment.formBuilder.appId),
            'x-header-authtoken': encodeURIComponent(this._authService.getAuthToken()),
            'x-header-refreshtoken': encodeURIComponent(this._authService.getRefreshToken()),
            'redirectUrl': encodeURIComponent(window.location.href.toString()),
            'formElementsEndPoint': encodeURIComponent('/api/assets/team/'),
            'taskTemplateId': encodeURIComponent(this._router.snapshot.params.id),
            'formState': encodeURIComponent(this.formObj.status)
        }
        if(this.formObj.status === 0) {
            this.formBuilderDetails.redirectUrl = encodeURIComponent(`${window.location.href.toString()}?fromEdit=true`);
        }
        this.formBuilderUrl = environment.formBuilder.serverUrl + '/api/v1/verifyTokens?' + 'data='
            + this.encode(this.formBuilderDetails);
        window.location.href = this.formBuilderUrl;
    }

    onPrint(template: any) {
        this._formsPreviewService.printTemplate(template._id).subscribe((data: any) => {
            const blob = new Blob([data], { type: 'application/zip' });
            saveAs(blob, `${template.name}.zip`);
        })
    }
}



// WEBPACK FOOTER //
// ./src/app/forms-preview/forms-preview.component.ts